<template>
  <div id="app">
    <div class="notification-container">
      <div
        v-for="(notification, index) in notifications"
        :key="index"
        class="notification"
        v-show="notification.visible"
      >
        <button class="close-button" @click="closeNotification(index)">
          ⨉
        </button>
        <div class="message-content">{{ notification.message }}</div>
        <div ref="mapContainers" class="map-container"></div>
        <div class="carousel-container">
          <button @click="prevImage(index)">‹</button>
          <img
            :src="notification.imageUrls[notification.currentImageIndex]"
            alt="slider image"
            @click="openModal(notification.imageUrls[notification.currentImageIndex])"
          />
          <button @click="nextImage(index)">›</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { alarmInfo } from "../api/huli.js";
import AMapLoader from "@amap/amap-jsapi-loader";

export default {
  name: "AMapLoader",

  data() {
    return {
      socket: null,
      message: "",
      map: null,
      marker: null,
      loaded: false,
      infoWindow: null,
      coordinate: "",
      notifications: [],
      imageUrls: [],
      isModalOpen: false,   // 控制模态显示状态
      currentImageUrl: '',  // 当前模态显示的大图URL
    };
  },
  created() {
    this.sendMessage(this.message);
    // 使用相对路径，通过代理连接WebSocket
    const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const wsUrl = `${wsProtocol}//${window.location.host}/api/alarm-websocket`;
    console.log('WebSocket连接URL:', wsUrl);
    this.socket = new WebSocket(wsUrl);
    this.socket.onmessage = (event) => {
      this.message = event.data;
      console.log(event.data);
      if (this.isNumber(event.data)) {
        alarmInfo(event.data).then((res) => {
          if (res?.data.code === 200) {
            this.showNotification();
            this.imageUrls = res?.data.data.imageUrls.split(",");
            this.coordinate = this.extractCoordinates(
              res?.data.data.coordinate
            );
            console.log(this.coordinate,'this.coordinate==========');
          }
        });
      }
    };
    this.socket.onopen = () => {
      console.log("WebSocket连接已打开");
    };

    this.socket.onerror = (error) => {
      console.error("WebSocket遇到错误:", error);
    };

    this.socket.onclose = () => {
      console.log("WebSocket连接已关闭");
    };
  },
  beforeDestroy() {
    if (this.socket) {
      this.socket.close();
    }
  },
  methods: {
    openModal(imageUrl) {
      this.currentImageUrl = imageUrl;
      this.isModalOpen = true;
    },
    extractCoordinates(inputString) {
      const longitudeMatch = inputString.match(/longitude:([\d.]+)/);
      const latitudeMatch = inputString.match(/latitude:([\d.]+)/);

      if (longitudeMatch && latitudeMatch) {
        const longitude = parseFloat(longitudeMatch[1]);
        const latitude = parseFloat(latitudeMatch[1]);
        return [longitude, latitude];
      }

      return null;
    },

    attemptAutoPlay() {
      const alarmSound = new Audio(require("@/assets/alarm.wav"));
      alarmSound.muted = true;
      alarmSound
        .play()
        .then(() => {
          alarmSound.muted = false;
        })
        .catch((error) => {
          console.error("自动播放失败: ", error);
        });
    },
    sendMessage(message) {
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        this.socket.send(message);
        console.log("发送消息:", message);
      } else {
        console.error("WebSocket未连接");
      }
    },
    isNumber(s) {
      return !isNaN(s) && s.trim() !== "";
    },

    showNotification() {
      const newNotification = {
        message: "警告！",
        visible: true,
        imageUrls: this.imageUrls,
        currentImageIndex: 0,
      };
      this.notifications.push(newNotification);
      this.$nextTick(this.initMap);
    },
    closeNotification(index) {
      this.notifications[index].visible = false;
    },
    prevImage(index) {
      const notification = this.notifications[index];
      notification.currentImageIndex =
        (notification.currentImageIndex - 1 + notification.imageUrls.length) %
        notification.imageUrls.length;
    },
    nextImage(index) {
      const notification = this.notifications[index];
      notification.currentImageIndex =
        (notification.currentImageIndex + 1) % notification.imageUrls.length;
    },
    async initMap() {
      try {
        const AMap = await AMapLoader.load({
          key: "WT2BZ-R4BEB-5XWUG-J7VSY-PTYTE-YDBHU",
          version: "1.4.15",
          plugins: ["AMap.Marker", "AMap.InfoWindow"],
        });

        this.$refs.mapContainers.forEach((mapContainer, index) => {
          if (!mapContainer.mapInstance && mapContainer.tagName) {
            const map = new AMap.Map(mapContainer, {
              center: this.coordinate,
              zoom: 15,
            });

            const marker = new AMap.Marker({
              position: [110.516398, 19.213315],
            });

            marker.setMap(map);

            const infoWindow = new AMap.InfoWindow({
              content: "琼海长养康宁医院附近",
              offset: new AMap.Pixel(0, -30),
            });

            marker.on("click", () => {
              infoWindow.open(map, marker.getPosition());
            });

            mapContainer.mapInstance = map;
          }
        });
      } catch (e) {
        console.error("地图加载失败: ", e);
      }
    },
    addMarker(AMap) {
      this.marker = new AMap.Marker({
        position: [110.516398, 19.213315],
      });

      this.marker.setMap(this.map);

      this.infoWindow = new AMap.InfoWindow({
        content: "琼海长养康宁医院附近",
        offset: new AMap.Pixel(0, -30),
      });

      this.marker.on("click", () => {
        this.infoWindow.open(this.map, this.marker.getPosition());
      });
    },
  },
};
</script>
<style lang='less' scoped>
.notification-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.notification {
  position: relative;
  width: 320px;
  padding: 15px;
  border: 1px solid #ccc;
  background-color: #fff;
  margin-top: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  transition: opacity 0.5s;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  border: none;
  background: transparent;
  font-size: 14px;
}

.map-container {
  width: 100%;
  height: 200px;
  margin-top: 10px;
}

/* 图片轮播器样式 */
.carousel-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}

.carousel-container img {
  width: 200px;
  height: auto;
  object-fit: cover;
  margin: 0 10px;
}

.carousel-container button {
  background-color: #fff;
  border: none;
  font-size: 18px;
  cursor: pointer;
}
</style>